module.exports = import("https://cdn.skypack.dev/web-haptics");;